// @flow

import React from 'react';
import styled from 'styled-components';

import colors from '../config/colors';

const NavHeaderTitle = styled.h3`
  background: ${colors.sidebar.bg};
  color: ${colors.text.light};
  display: inline;
  font-size: 20px;
  font-weight: 300;
  padding: 0 1em;
  position: relative;
  text-transform: uppercase;
`;

const NavHeaderWrapper = styled.header`
  position: relative;
  text-align: center;
  &:before {
    background: ${colors.text.light};
    background: linear-gradient(
      to right,
      ${colors.sidebar.bg} 0%,
      ${colors.text.light} 50%,
      ${colors.sidebar.bg} 100%
    );
    content: '';
    height: 2px;
    left: 10%;
    margin-top: -1px;
    padding: 0 25%;
    position: absolute;
    right: 10%;
    top: 50%;
  }
`;

type Props = {
  title: string
};

const NavHeader = ({ title }: Props) => (
  <NavHeaderWrapper>
    <NavHeaderTitle>{title}</NavHeaderTitle>
  </NavHeaderWrapper>
);

export default NavHeader;



// WEBPACK FOOTER //
// ./src/components/NavHeader.js